The descriptions for the position profile.

Currently, only the `AdvertisementDetails` description is used.
Other descriptions will be accepted but are ignored when determining the relevance of suggestion.

The job category suggestion algorithm is designed to work with the complete advertisement details as they would appear on the final job ad.
Providing incomplete or placeholder text in this field may result in irrelevant suggestions.
